// extracted by mini-css-extract-plugin
module.exports = {"tab-title":"dashboard-common_tab-title__DRABX"};